import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadGetNextDocumentNumberAtom = createMutationAtomFactory(
  'trade.loadGetNextDocumentNumber',
  () => ({
    tradeLoadNextDocumentNumber: true,
  }),
);
